"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.precision = precision;
exports.recall = recall;
exports.f1 = f1;
const lodash_1 = require("lodash");
function precision({ truePositives, falsePositives, numDigits = 3, }) {
    const result = truePositives + falsePositives === 0 ? 0 : truePositives / (truePositives + falsePositives);
    return (0, lodash_1.round)(result, numDigits);
}
function recall({ truePositives, falseNegatives, numDigits = 3, }) {
    const result = truePositives + falseNegatives === 0 ? 0 : truePositives / (truePositives + falseNegatives);
    return (0, lodash_1.round)(result, numDigits);
}
function f1({ precision, recall, numDigits = 3, }) {
    const result = precision + recall === 0 ? 0 : (2 * (precision * recall)) / (precision + recall);
    return (0, lodash_1.round)(result, numDigits);
}
//# sourceMappingURL=metrics-formulas.js.map